import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { playSound } from "@/app/utils";

export function useNavigationSound() {
  const pathname = usePathname();
  const isInitialRender = useRef(true);

  useEffect(() => {
    // Skip sound on initial page load/mount
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    // Play tap sound on route change
    playSound("tap");
  }, [pathname]);
}
